import { render, staticRenderFns } from "./CardDetailTrans.vue?vue&type=template&id=15d1371e&scoped=true&"
import script from "./CardDetailTrans.vue?vue&type=script&lang=js&"
export * from "./CardDetailTrans.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailTrans.vue?vue&type=style&index=0&id=15d1371e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d1371e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCol,VDivider,VImg,VRow,VTooltip})
